module.exports = __webpack_public_path__ + "static/img/onlinebottom2.6a19485.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/we/onlinebottom2.png
 ** module id = 598
 ** module chunks = 2
 **/